<template>
        <footer class="footer hidden-print">
            <div class="container">
              
                <div class="row">
                    <div class="col-sm-3">
                        <img src="https://njmonthly.com/wp-content/uploads/2014/11/njm_logo-2021.png" alt="New Jersey Monthly" width="230" height="51" />
                    </div>
                    <div class="col-sm-6 col-sm-offset-3 col-md-height">
                        <aside id="nav_menu-7" class="widget-odd widget-first widget-1 widget widget_nav_menu">
                            <!-- <h2 class="widget-title">Additional Links</h2>
                            <div class="menu-subscription-container">
                                <ul id="menu-subscription" class="menu">
                                  <div>
                                    <li class="menu-item menu-item-type-custom menu-item-object-custom"><router-link to="/user/password_reset_email">Reset Password</router-link></li>
                                  </div>
                                </ul>
                            </div> -->
                        </aside>
                    </div>
                </div>
            </div>

 
        </footer>
</template>
<script>
export default {
  name: 'global-footer',
}
</script>

<style lang="scss">

</style>
